/*
 * @Author: cmchiu
 * @Date: 2022-09-30 15:20:13
 * @LastEditTime: 2022-09-30 15:51:46
 * @LastEditors: cmchiu
 * @Description:
 * @FilePath: \LearningMarket\LearningMarket-ClientApp\src\utils\common.js
 *
 */
function checkFormat(ruleReg, value) {
    if (ruleReg.test(value)) {
        return true
    } else {
        return false
    }
}

function checkPhone(rule, value, callback) {
    const phoneReg = /^\d{2,3}-?\d{7,8}|09\d{2}-?(\d{6})$/
    if (!value) {
        return callback(new Error('請輸入聯絡電話'))
    }
    setTimeout(() => {
        if (checkFormat(phoneReg, value)) {
            callback()
        } else {
            callback(new Error('聯絡電話格式不正確'))
        }
    }, 100)
}

function checkEmail(rule, value, callback) {
    const mailReg = /^\w+((-\w+)|(_\w+)|(\.\w+)|(\+\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/
    if (!value) {
        return callback(new Error('請輸入Email'))
    }
    setTimeout(() => {
        if (checkFormat(mailReg, value)) {
            callback()
        } else {
            callback(new Error('Email格式不正確'))
        }
    }, 100)
}

export { checkFormat, checkPhone, checkEmail }
